'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {
    CONSTRUCTION_PAGE_ACCORDION_BLOCK_CONTENT,
} from "../../common/constants/industries";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import React, {useState} from "react";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {TitleImageSection} from "@/app/[locale]/common/components/TitleImageSection/TitleImageSection";
import main from '@/app/[locale]/common/assets/images/slider-main/slide_2.webp';
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {TConstructionIsOpen, TTasksCardContent} from "@/app/[locale]/industries/types";
import {TaskCard} from "@/app/[locale]/common/components/TaskCard/TaskCard";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import technical_options from '../../common/assets/images/industires/construction/technical-options.webp';
import Image from "next/image";
import {AccordionBlock} from "@/app/[locale]/common/components/AccordionBlock/AccordionBlock";
import infoBlock from '../../common/assets/images/industires/construction/infoBlock.webp';
import {SliderBlock} from "@/app/[locale]/common/components/SliderBlock/SliderBlock";
import {DieselGeneratorSlideCard} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/DieselGeneratorSlideCard";
import {TDieselGeneratorSlideCardProps} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/types";
import {useTranslations} from "next-intl";
import {FuelIcon} from "@/app/[locale]/common/assets/FuelIcon/FuelIcon";
import {HumonIcon} from "@/app/[locale]/common/assets/HumonIcon/HumonIcon";
import {LocationIcon} from "@/app/[locale]/common/assets/LocationIcon/LocationIcon";
import {TimeTrackingIcon} from "@/app/[locale]/common/assets/TimeTrackingIcon/TimeTrackingIcon";
import {AxleLoadIcon} from "@/app/[locale]/common/assets/AxleLoadIcon/AxleLoadIcon";
import slide1_construction
    from "@/app/[locale]/common/assets/images/industires/construction/slider-cases/slide1_construction.webp";
import slide2_construction
    from "@/app/[locale]/common/assets/images/industires/construction/slider-cases/slide2_construction.webp";
import slide3_construction
    from "@/app/[locale]/common/assets/images/industires/construction/slider-cases/slide3_construction.webp";

export default function Construction() {
    const t = useTranslations('ConstructionPage');

    const [ isOpen, setIsOpen ] = useState<TConstructionIsOpen>(
        Object.fromEntries(CONSTRUCTION_PAGE_ACCORDION_BLOCK_CONTENT.map((item) => item.id === '1' ? [item.id, true] : [item.id, false]))
    );

    const handleOpenAccordion = (id: string) => {
        setIsOpen(() => ({
            [id]: true,
        }));
    };

    const taskCardsIcons = [FuelIcon, HumonIcon, LocationIcon, TimeTrackingIcon, AxleLoadIcon];
    const taskCards = t.raw('taskBlock.cardsData').map((item: {title: string}, index: number) => ({...item, Icon: taskCardsIcons[index]}));
    const casesImages = [slide1_construction, slide2_construction, slide3_construction];
    const casesContent = t.raw('cases.cardsData').map((item: {label: string, task: string, solution: string}, index: number) => ({...item, image: casesImages[index]}));

    return (
        <div className={s.construction}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.INDUSTRIES'), t.raw('breadcrumbs.CONSTRUCTION')]}/>
                <TitleImageSection
                    title={t('title')}
                    image={main}
                />

                <div className={s.construction_tasks}>
                    <Title title={t('taskBlock.title')}/>

                    <div className={s.construction_tasks_textContainer}>
                        <p className={s.construction_tasks_textContainer_text}>
                            {t('taskBlock.text')}
                        </p>
                        <div className={s.construction_tasks_textContainer_paragraphLine}>
                            <ParagraphLine>{t('taskBlock.paragraphLine')}</ParagraphLine>
                        </div>
                    </div>

                    <div className={s.construction_tasks_container}>
                        {
                            taskCards.map((item: TTasksCardContent, index: number) => (
                                <TaskCard
                                    key={index}
                                    Icon={item.Icon}
                                    title={item.title}
                                />
                            ))
                        }
                    </div>
                </div>

                <div className={s.construction_options}>
                    <Title title={t('options.title')}/>

                    <div className={s.construction_options_cardsContainer}>
                        {
                            t.raw('options.list').map((item: {
                                title: string
                            }, index: number) => (
                                <div
                                    key={index}
                                    className={s.construction_options_card}
                                >
                                        <span>
                                            <ConfirmIcon/>
                                        </span>
                                    {item.title}
                                </div>
                            ))
                        }
                    </div>
                    <div className={s.construction_options_imageContainer}>
                        <Image src={technical_options} alt={'technical_options'}/>
                    </div>
                </div>

                <div className={s.construction_infoBlock}>
                    <Title title={t('infoBlock.title')} />

                    <div className={s.construction_infoBlock_container}>
                        <AccordionBlock
                            isOpen={isOpen}
                            data={t.raw('infoBlock.data')}
                            onClick={handleOpenAccordion}
                        />
                        <div className={s.construction_infoBlock_imageContainer}>
                            <Image src={infoBlock} alt={'infoBlock'} />
                        </div>
                    </div>
                </div>

                <SliderBlock
                    label={t('cases.title')}
                    navigationId={'cases'}
                    data={casesContent}
                    card={(item, index) => (
                        <DieselGeneratorSlideCard
                            key={index}
                            label={item.label}
                            task={(item as TDieselGeneratorSlideCardProps).task}
                            solution={(item as TDieselGeneratorSlideCardProps).solution}
                            image={(item as TDieselGeneratorSlideCardProps).image}
                        />
                    )}
                />

                <ContactUs/>
            </Container>
        </div>
    );
};